// extracted by mini-css-extract-plugin
export default {"ColSty":"ProjectTotalIncome_ColSty__YqfG5","ColContent":"ProjectTotalIncome_ColContent__gvXNn"};